var exports = {
  "Q": "xae11d333--321bb2--content",
};

module.exports = exports;
